import { SponsorType } from "./sponsor-type.enum";

export class SponsorList {
    name: string;
    company: string;
    requestReceipt: boolean;
    amount: number;
    hasPaid: boolean;
    stripeReferenceId: string;
    type: SponsorType;
    notes: string;
}
